// extracted by mini-css-extract-plugin
export default {"projectTextInput":"TextField-module__projectTextInput--HNcsT"};